<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal invalid-eol-scenario-container">
    <table class="scenario-table">
      <thead>
        <tr>
          <th class="scenario-name-column">Scenario Name</th>
          <th class="scenario-action-column">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let scenario of scenarioList">
          <td class="scenario-name">{{ scenario.scenarioName }}</td>
          <td class="scenario-action">
            <button
              class="action-button"
              [ngClass]="{ selected: selectedScenarioIds.includes(scenario.scenarioId) }"
              (click)="navigateToScenario(scenario, componentName)"
            >
              {{ componentName == 'fill-data-list' ? 'Go to filling' : 'Go to EOL rates' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      *ngIf="componentName != 'fill-data-list'"
      type="button"
      class="actionBTN modelBtn"
      (click)="updateAll()"
    >
      Update all
    </button>
  </div>
</div>
